import { Card, Typography } from "@codat/orchard-ui";
import { Product } from "api/schema/productsSchema";
import classNames from "classnames";
import React from "react";
import { getProductDetails } from "utils";

import styles from "./ProductSelectCard.module.scss";

export interface ProductSelectCardProps {
  selected: boolean;
  product: Product;
  onCardClick: () => void;
}

export function ProductSelectCard({
  selected,
  product,
  onCardClick,
}: ProductSelectCardProps) {
  const productDetails = getProductDetails(product);
  const { onboardingCopy, Icon, colorTheme } = productDetails;
  return (
    <Card
      size="small"
      className={classNames(
        styles.productCard,
        selected && styles.selected,
        styles[colorTheme]
      )}
      onClick={onCardClick}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onCardClick();
        }
      }}
      data-testid="product-card"
      data-selected={selected}
      tabIndex={0}
      role="button"
    >
      <div className={styles.cardContent}>
        <Icon />
        <div className={styles.textWrapper}>
          <Typography as="h2" variant="heading_md">
            {product?.name ?? "Unknown product"}
          </Typography>
          <Typography as="p" variant="body_sm">
            {onboardingCopy}
          </Typography>
        </div>
      </div>
    </Card>
  );
}
